/* La sfilata della sezione invito, terza versione: lo stesso foglio del banco
   del configuratore, disegnato come lo disegna il motore.
   - Il legno e' UNA sagoma con i buchi (fill-rule evenodd su frontale + lenti
     + fori): cosi' i modelli a doppio ponte hanno il loro foro centrale e il
     legno NON si vede in trasparenza sotto le lenti.
   - Le lenti stanno SOTTO il legno, come nel configuratore: piene, sfumate o
     specchiate (le sfumature vere del motore), con il riflesso a ellisse, la
     lama di luce e il bordo interno sfocato.
   - Il contorno a china passa anche sui bordi delle lenti e dei fori, perche'
     e' un solo path evenodd, come al banco.
   Il ritmo: un battito ogni secondo (dimezzato il 15/8 su richiesta), e i tre
   cambi si danno il turno a terzi di battito: forma, poi legno, poi lente,
   ogni 333 ms cambia UNA cosa sola. Cosi' l'occhio segue ogni cambio invece
   di vederne tre insieme.
   ⚠️ Le quote si calcolano dai PUNTI delle forme (bbox in millimetri), non dal
   disegno gia' montato: getBBox su un SVG nascosto torna zero. */
(function () {
  'use strict';

  /* Il foglio del banco, stessi numeri di creo-configuratore.js:
     china, matita, testo a matita, grafia a mano. */
  var INK = '#5f4f3a', PEN = '#6b655d', PENT = '#55504a',
    MANO = "'Architects Daughter','Segoe Print','Bradley Hand',cursive";

  function accendi(sez) {
    if (!sez || sez.getAttribute('data-acceso')) return;
    var telaio = sez.querySelector('.creo-invito__telaio');
    if (!telaio) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var legni = [];
    try { legni = JSON.parse(sez.getAttribute('data-legni') || '[]'); } catch (e) { legni = []; }
    if (!legni.length) return;
    sez.setAttribute('data-acceso', '1');
    var FIRMA = sez.getAttribute('data-firma') || 'vista frontale, mm';
    /* le etichette delle quote, dall'editor: quattro parole separate da | */
    var QL = (sez.getAttribute('data-quote') || 'Calibro|Ponte|Larghezza|Altezza').split('|');

    /* Le lenti VERE del configuratore: colore piu' il tipo (g = sfumata,
       m = specchiata). Stessi esadecimali di var LENTI nel motore. */
    var LENTI = [
      { c: '#33383f' }, { c: '#3a3f47', g: 1 }, { c: '#1f2226' },
      { c: '#4a2f1c' }, { c: '#5a3a22', g: 1 }, { c: '#2a1a10' },
      { c: '#22483a' }, { c: '#22483a', g: 1 },
      { c: '#27476d' }, { c: '#274a6d', g: 1 }, { c: '#3d6f96', g: 1 },
      { c: '#7fb2d8', m: 1 }, { c: '#aeb6bd', m: 1 }, { c: '#c8a24a', m: 1 },
      { c: '#6a4a8c' }, { c: '#4a3560', g: 1 },
      { c: '#d98fa8' }, { c: '#c9a227' }, { c: '#c2611f' }
    ];

    /* Margini del foglio attorno alla forma piu' grande, in mm del disegno.
       Dal 17/8 il ponte sta sotto (+2,6) e il numero dell'altezza sotto la sua
       barra: sopra bastano 4 mm e a destra 11 dove prima ne servivano 8 e 30.
       Sotto restano ponte, calibro (+5), larghezza (+11) e la firma. Stessi
       numeri del riquadro del banco. */
    var MS = 4, MD = 11, MG = 19, MX = 6;
    var forme = null, W = 156, H = 64, TW = 0, TH = 0, iF = 0, iL = -1, iV = -1;
    var legno = legni[0].u, lente = LENTI[0];
    var battito = null, chiesto = false, passo = 0;
    /* Ogni elemento cambia una volta ogni DUE secondi: dimezzato il 15/8
       («l'animazione e' troppo veloce»), poi dimezzato di nuovo su sua
       richiesta. UN SOLO timer a giro di tre: forma, legno, lente, una cosa
       ogni due terzi di secondo, mai due insieme.
       ⚠️ Non tre timer sfalsati: in una scheda in secondo piano Chrome
       allinea tutti i timer al secondo pieno e i tre sfalsamenti collassano
       nello stesso istante. Col giro unico, anche rallentato, ogni battito
       cambia comunque UNA cosa sola. */
    var TERZO = 668;

    function via(pt) {
      var d = 'M' + pt[0][0].toFixed(1) + ' ' + pt[0][1].toFixed(1);
      for (var i = 1; i < pt.length; i++) d += 'L' + pt[i][0].toFixed(1) + ' ' + pt[i][1].toFixed(1);
      return d + 'Z';
    }
    function scatola(pt) {
      var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9;
      for (var i = 0; i < pt.length; i++) {
        if (pt[i][0] < x0) x0 = pt[i][0]; if (pt[i][0] > x1) x1 = pt[i][0];
        if (pt[i][1] < y0) y0 = pt[i][1]; if (pt[i][1] > y1) y1 = pt[i][1];
      }
      return { x0: x0, y0: y0, x1: x1, y1: y1, w: x1 - x0, h: y1 - y0,
        cx: (x0 + x1) / 2, cy: (y0 + y1) / 2 };
    }

    function prepara(dati) {
      var out = [], mw = 0, mh = 0;
      for (var k in dati) {
        var m = dati[k];
        if (!m || !m.front || m.front.length < 8) continue;
        var lenti = [];
        for (var j = 0; j < (m.lenti || []).length; j++) {
          var l = m.lenti[j];
          if (l && l.length > 6) lenti.push({ d: via(l), b: scatola(l) });
        }
        var fori = [];
        for (var j2 = 0; j2 < (m.fori || []).length; j2++) {
          var fo = m.fori[j2];
          if (fo && fo.length > 6) fori.push(via(fo));
        }
        /* la sagoma intera: frontale + buchi delle lenti + fori del doppio
           ponte, un solo path evenodd come nel motore */
        var tutto = via(m.front);
        for (var j3 = 0; j3 < lenti.length; j3++) tutto += ' ' + lenti[j3].d;
        if (fori.length) tutto += ' ' + fori.join(' ');
        var sca = lenti.map(function (o) { return o.b; })
          .sort(function (a, b) { return a.x0 - b.x0; });
        if (m.w > mw) mw = m.w;
        if (m.h > mh) mh = m.h;
        out.push({ w: m.w, h: m.h, label: m.label || k, tutto: tutto, lenti: lenti, sca: sca });
      }
      /* la cornice si prende dalla forma piu' grande del catalogo, non a
         occhio: cosi' nessuna esce e le proporzioni fra i modelli restano vere */
      W = Math.ceil(mw); H = Math.ceil(mh);
      TW = W + MX + MD; TH = H + MS + MG;
      telaio.style.aspectRatio = TW + ' / ' + TH;
      for (var i = out.length - 1; i > 0; i--) {
        var r = Math.floor(Math.random() * (i + 1)), t = out[i]; out[i] = out[r]; out[r] = t;
      }
      return out;
    }

    /* Quota come al banco: linea con i baffetti, numero a matita.
       `giu` come nel motore (17/8): sulle verticali il numero va sotto la
       barra, allineato a destra, invece che di fianco. */
    function quota(x1, y1, x2, y2, label, giu) {
      var vert = Math.abs(x2 - x1) < .01,
        mx = (x1 + x2) / 2, my = (y1 + y2) / 2,
        t1 = vert ? 'M' + (x1 - 1.4).toFixed(1) + ' ' + y1.toFixed(1) + 'H' + (x1 + 1.4).toFixed(1)
                  : 'M' + x1.toFixed(1) + ' ' + (y1 - 1.4).toFixed(1) + 'V' + (y1 + 1.4).toFixed(1),
        t2 = vert ? 'M' + (x2 - 1.4).toFixed(1) + ' ' + y2.toFixed(1) + 'H' + (x2 + 1.4).toFixed(1)
                  : 'M' + x2.toFixed(1) + ' ' + (y2 - 1.4).toFixed(1) + 'V' + (y2 + 1.4).toFixed(1),
        tx = vert ? (giu ? x1 + 1.4 : mx + 2.2) : mx, ty = vert ? (giu ? Math.max(y1, y2) + 3.6 : my + 1.4) : my - 1.2, anc = vert ? (giu ? 'end' : 'start') : 'middle';
      return '<g><path d="M' + x1.toFixed(1) + ' ' + y1.toFixed(1) + 'L' + x2.toFixed(1) + ' ' + y2.toFixed(1) + t1 + t2 +
        '" stroke="' + PEN + '" stroke-width=".32" fill="none" opacity=".8" stroke-linecap="round"/>' +
        '<text x="' + tx.toFixed(1) + '" y="' + ty.toFixed(1) + '" text-anchor="' + anc + '" font-size="3.6" font-family="' + MANO + '" fill="' + PENT + '" opacity=".92">' + label + '</text></g>';
    }

    /* Il riempimento della lente corrente: pieno, sfumato o specchiato. */
    function pitturaLente() {
      return lente.m ? 'url(#creoMir)' : lente.g ? 'url(#creoGr)' : lente.c;
    }

    function disegnaForma() {
      var f = forme[iF % forme.length]; iF++;
      var dx = (W - f.w) / 2, dy = (H - f.h) / 2;
      /* le quote della forma, dai suoi punti */
      var q = '';
      if (f.sca.length) {
        var sx = f.sca[0];
        q += quota(sx.x0, f.h + 5, sx.x1, f.h + 5, QL[0] + ' ' + Math.round(sx.w));
        if (f.sca.length > 1) {
          /* Il ponte sotto il frontale, un rigo sopra il calibro, come al
             banco (17/8): sopra finiva addosso ai modelli a ponte alto. */
          var dxp = f.sca[f.sca.length - 1];
          q += quota(sx.x1, f.h + 2.6, dxp.x0, f.h + 2.6, QL[1] + ' ' + Math.round(dxp.x0 - sx.x1));
        }
      }
      q += quota(0, f.h + 11, f.w, f.h + 11, QL[2] + ' ' + Math.round(f.w));
      q += quota(f.w + 7, 0, f.w + 7, f.h, QL[3] + ' ' + Math.round(f.h), true);
      var firma = '<text x="' + (2 - MX) + '" y="' + (H + MG - 2.2).toFixed(1) + '" font-size="3.4" font-family="' + MANO + '" fill="' + PENT + '" opacity=".55">CREO Positano Glasses · ' + f.label + ' · ' + FIRMA + '</text>';

      var fillL = pitturaLente(), clips = '', lentiHtml = '';
      for (var i = 0; i < f.lenti.length; i++) {
        var b = f.lenti[i].b, d = f.lenti[i].d;
        clips += '<clipPath id="creoKL' + i + '"><path d="' + d + '"/></clipPath>';
        /* la lente come nel motore: colore pieno sotto, riflesso a ellisse,
           lama di luce, bordo interno sfocato */
        lentiHtml += '<path class="creo-invito__lente" d="' + d + '" fill="' + fillL + '"/>' +
          '<g clip-path="url(#creoKL' + i + ')">' +
          '<ellipse cx="' + (b.cx - b.w * .16).toFixed(1) + '" cy="' + (b.y0 + b.h * .3).toFixed(1) +
          '" rx="' + (b.w * .34).toFixed(1) + '" ry="' + (b.h * .2).toFixed(1) +
          '" fill="url(#creoHi)" transform="rotate(-16 ' + (b.cx - b.w * .16).toFixed(1) + ' ' + (b.y0 + b.h * .3).toFixed(1) + ')"/>' +
          '<path d="M ' + (b.x0 - 2).toFixed(1) + ' ' + (b.y1 + 1).toFixed(1) +
          ' Q ' + b.cx.toFixed(1) + ' ' + (b.cy + b.h * .1).toFixed(1) +
          ' ' + (b.x1 + 2).toFixed(1) + ' ' + (b.y0 + b.h * .25).toFixed(1) +
          '" stroke="#ffffff" stroke-width="' + (b.h * .13).toFixed(1) + '" fill="none" opacity=".1"/>' +
          '<path d="' + d + '" fill="none" stroke="#000" stroke-width="2" opacity=".3" filter="url(#creoBlu2)"/>' +
          '</g>';
      }

      var s = '<svg class="creo-invito__sag" viewBox="' + (-MX) + ' ' + (-MS) + ' ' + TW + ' ' + TH + '" ' +
        'xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + f.label + '">' +
        '<defs>' +
        /* il tassello vero e' 170 x 80 mm: la venatura si vede alla sua scala */
        '<pattern id="creoLegno" patternUnits="userSpaceOnUse" width="170" height="80">' +
        '<image class="creo-invito__tex" href="' + legno + '" x="0" y="0" width="170" height="80" preserveAspectRatio="xMidYMid slice"/></pattern>' +
        /* i quadretti del foglio, 10 mm come al banco */
        '<pattern id="creoMM" patternUnits="userSpaceOnUse" width="10" height="10">' +
        '<path d="M10 0H0V10" fill="none" stroke="#8a7a5f" stroke-width=".2" opacity=".28"/>' +
        '<path d="M5 0V10M0 5H10" fill="none" stroke="#8a7a5f" stroke-width=".13" opacity=".17"/></pattern>' +
        /* le sfumature vere delle lenti, dal motore */
        '<linearGradient id="creoGr" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + lente.c + '" stop-opacity=".92"/><stop offset="1" stop-color="' + lente.c + '" stop-opacity=".3"/></linearGradient>' +
        '<linearGradient id="creoMir" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".8"/><stop offset=".45" stop-color="' + lente.c + '"/><stop offset="1" stop-color="' + lente.c + '" stop-opacity=".85"/></linearGradient>' +
        '<radialGradient id="creoHi" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#fff" stop-opacity=".34"/><stop offset=".7" stop-color="#fff" stop-opacity=".08"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
        '<filter id="creoBlu2"><feGaussianBlur stdDeviation="1.1"/></filter>' +
        clips +
        '</defs>' +
        /* il foglio: carta bianca e quadretti fino ai bordi */
        '<rect x="' + (-MX) + '" y="' + (-MS) + '" width="' + TW + '" height="' + TH + '" fill="#ffffff"/>' +
        '<rect x="' + (1 - MX) + '" y="' + (1 - MS) + '" width="' + (TW - 2) + '" height="' + (TH - 2) + '" fill="url(#creoMM)"/>' +
        '<g transform="translate(' + dx.toFixed(1) + ' ' + dy.toFixed(1) + ')">' +
        /* lo spessore: sotto la sagoma una lama d'ombra, come al banco */
        '<g transform="translate(.75,1.15)"><path d="' + f.tutto + '" fill-rule="evenodd" fill="#2a1a0c" opacity=".18"/></g>' +
        /* le lenti SOTTO il legno */
        lentiHtml +
        /* il legno con i buchi: lenti e fori sono vuoti veri, non velature */
        '<path d="' + f.tutto + '" fill-rule="evenodd" fill="url(#creoLegno)"/>' +
        /* il contorno a china, anche sui bordi di lenti e fori */
        '<path d="' + f.tutto + '" fill-rule="evenodd" fill="none" stroke="' + INK + '" stroke-width=".38" opacity=".7"/>' +
        q + '</g>' + firma + '</svg>';
      telaio.innerHTML = s;
    }

    function cambiaLegno() {
      var i = Math.floor(Math.random() * legni.length);
      while (i === iL && legni.length > 1) i = Math.floor(Math.random() * legni.length);
      iL = i;
      legno = legni[i].u;
      var im = telaio.querySelector('.creo-invito__tex');
      if (im) im.setAttribute('href', legno);
    }

    function cambiaLente() {
      var i = Math.floor(Math.random() * LENTI.length);
      while (i === iV) i = Math.floor(Math.random() * LENTI.length);
      iV = i;
      lente = LENTI[i];
      /* le sfumature seguono il colore nuovo, poi si ridipingono le lenti */
      var gr = telaio.querySelector('#creoGr');
      if (gr) { gr.children[0].setAttribute('stop-color', lente.c); gr.children[1].setAttribute('stop-color', lente.c); }
      var mr = telaio.querySelector('#creoMir');
      if (mr) { mr.children[1].setAttribute('stop-color', lente.c); mr.children[2].setAttribute('stop-color', lente.c); }
      var fillL = pitturaLente();
      var l = telaio.querySelectorAll('.creo-invito__lente');
      for (var j = 0; j < l.length; j++) l[j].setAttribute('fill', fillL);
    }

    function tic() {
      if (!forme) return;
      /* nell'editor del tema la sezione viene sostituita: il giro vecchio si
         ferma da solo appena scopre di disegnare su un telaio staccato */
      if (!document.contains(sez)) { if (battito) { clearInterval(battito); battito = null; } forme = null; return; }
      var k = passo % 3; passo++;
      if (k === 0) disegnaForma();
      else if (k === 1) cambiaLegno();
      else cambiaLente();
    }

    function parti() {
      cambiaLegno(); cambiaLente(); disegnaForma();
      passo = 1;
      battito = setInterval(tic, TERZO);
    }

    function carica() {
      if (chiesto) return;
      chiesto = true;
      var url = sez.getAttribute('data-forme');
      if (!url) return;
      /* le scansioni si scaldano prima, se no il primo cambio si vede vuoto */
      for (var i = 0; i < legni.length; i++) { var im = new Image(); im.src = legni[i].u; }
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        forme = prepara(d);
        if (forme.length) parti();
      })['catch'](function () { });
    }

    if (window.requestIdleCallback) requestIdleCallback(carica, { timeout: 3000 });
    else setTimeout(carica, 1400);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden && battito) { clearInterval(battito); battito = null; }
      else if (!document.hidden && forme && !battito) battito = setInterval(tic, TERZO);
    });
  }

  function tutte() {
    var l = document.querySelectorAll('.creo-invito');
    for (var i = 0; i < l.length; i++) accendi(l[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tutte);
  } else tutte();
  document.addEventListener('shopify:section:load', tutte);
  setTimeout(tutte, 1500);
})();
